import { observable, makeObservable } from "mobx";

class FiltroArvorePeticaoStore {
    drawerAberto = false;
    situacaoPeticao = '';
    situacaoMinutaPeticao = '';

    constructor() {
        makeObservable(this, {
            drawerAberto: observable,
            situacaoPeticao: observable,
            situacaoMinutaPeticao: observable
        });
    }
}

export default new FiltroArvorePeticaoStore();